import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { OrchidFormsModule } from "@upmc-healthplan-npm/ods-ng";

import { GroupSearchPipe } from "./pipes/group-search.pipe";
import { MemberSearchPipe } from "./pipes/member-search.pipe";
import { EpDropdownPipe } from "./pipes/ep-dropdown.pipe";
import { EpDropdownPipeItem } from "./pipes/ep-dropdown-item.pipe";

import { EpDropdownComponent } from "./components/ep-dropdown/ep-dropdown.component";
import { EpDateInputComponent } from "./components/ep-date-input/ep-date-input.component";
import { EpDateInputDirective } from "./components/ep-date-input/ep-date-input.directive";
import { EpPopupComponent } from "./components/ep-popup/ep-popup.component";
import { EpConfirmDialogComponent } from "./components/ep-confirm-dialog/ep-confirm-dialog.component";
import { PlanselectDropdownCheckboxComponent } from "./components/planselect-dropdown-checkbox/planselect-dropdown-checkbox.component";
// tslint:disable:max-line-length
import { PlanAdminProductPanelComponent } from "./components/renewals/planAdminProduct-panel/plan-admin-product-panel.component";
import { MemberEnrollmentPanelComponent } from "./components/renewals/member-enrollment-panel/member-enrollment-panel.component";

import { ValidationAddressComponent } from "./components/validation-address/validation-address.component";
import { ErrorDialogueComponent } from "./components/error-dialogue/error-dialogue.component";
import { EpLoadingScreenComponent } from "./components/ep-loading-screen/ep-loading-screen.component";

import { EpQuoteDeclinationPopupComponent } from "./components/ep-quote-declination/ep-quote-declination.component";

import { PhonePipe } from "./pipes/phone.pipe";
import { EpNotificationComponent } from "./components/ep-notification/ep-notification.component";
import { NumbersOnlyDirective } from "./components/renewals/member-enrollment-panel/numbers-only.directive";

import { EpTimeoutComponent } from "./components/ep-timeout/ep-timeout.component";
import { CountdownComponent } from "ngx-countdown";
import { GroupInfoExpandedComponent } from "./components/group-info-expanded/group-info-expanded.component";
import { IneligibilityDialogComponent } from "../main/quoting/ineligibility-dialog/ineligibility-dialog.component";

// tslint:enable:max-line-length
@NgModule({
  declarations: [
    GroupSearchPipe,
    MemberSearchPipe,
    EpDropdownComponent,
    EpDropdownPipe,
    EpDropdownPipeItem,
    EpDateInputComponent,
    EpDateInputDirective,
    EpPopupComponent,
    EpConfirmDialogComponent,
    PlanAdminProductPanelComponent,
    MemberEnrollmentPanelComponent,
    ValidationAddressComponent,
    ErrorDialogueComponent,
    EpLoadingScreenComponent,
    EpQuoteDeclinationPopupComponent,
    PlanselectDropdownCheckboxComponent,
    PhonePipe,
    EpNotificationComponent,
    NumbersOnlyDirective,
    EpTimeoutComponent,
    GroupInfoExpandedComponent,
    IneligibilityDialogComponent,
  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    CountdownComponent,
    OrchidFormsModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EpDropdownComponent,
    GroupSearchPipe,
    EpDateInputComponent,
    EpDateInputDirective,
    EpPopupComponent,
    EpConfirmDialogComponent,
    PlanAdminProductPanelComponent,
    MemberEnrollmentPanelComponent,
    ValidationAddressComponent,
    ErrorDialogueComponent,
    EpLoadingScreenComponent,
    EpQuoteDeclinationPopupComponent,
    PlanselectDropdownCheckboxComponent,
    PhonePipe,
    EpNotificationComponent,
    EpTimeoutComponent,
    GroupInfoExpandedComponent,
    IneligibilityDialogComponent,
    CountdownComponent,
    OrchidFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
